<template>
    <div class="con">
        <div class="contain">
            <div class="title">
                <div class="titBorder"></div>
                {{title}}
            </div>
            <div class="slotBox">
                <slot></slot>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: {
                default: '',
                type: String
            }
        },
        data () {
            return {

            }
        }
    }
</script>
<style scoped lang="less">
    .con {
        margin-bottom: 20px;
    }

    .slotBox {
        padding: 16px;
    }

    .contain {
        border: 1px solid #f7f7ff;

        .title {
            height: 30px;
            line-height: 11px;
            background-color: #f7f7ff;
            position: relative;
            padding-left: 28px;
            font-size: 14px;

            .titBorder {
                position: absolute;
                width: 4px;
                height: 14px;
                background-color: #2d8cf0;
                top: 8px;
                left: 16px;
            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/common/detailBox.vue